module.exports = __webpack_public_path__ + "static/media/facebook.ceda85dc.png";